import { get } from 'js-cookie';
import Prismic from 'prismic-javascript';

export const isPreviewActive = (): boolean => {
    return !!(get(Prismic.experimentCookie) || get(Prismic.previewCookie));
};
